module.exports = __webpack_public_path__ + "static/media/product_var_hig.55bde58e.png";